import apiClient from "./client";

export const fetchReports = async (page = 1, pageSize = 10, filters = {}) => {
  const { reviewFilter, startDate, endDate } = filters;
  try {
    const { data } = await apiClient.get("api/incident-reports/", {
      params: {
        page,
        page_size: pageSize,
        review_status: reviewFilter || undefined,
        start_date: startDate || undefined,
        end_date: endDate || undefined,
      },
    });
    
    
    // Check if it's GeoJSON FeatureCollection (non-paginated)
    if (data?.type === "FeatureCollection" && Array.isArray(data?.features)) {
      const mappedReports = data.features.map((f) => ({
        id:                     f.id || f.properties?.id,
        reported_at:            f.properties?.reported_at,
        description:            f.properties?.description,
        image:                  f.properties?.image,
        stakeholder_confirmed:  f.properties?.stakeholder_confirmed,
        confirmed_at:           f.properties?.confirmed_at,
        solved:                 f.properties?.solved,
        solved_at:              f.properties?.solved_at,
        location: {
          lat: f.geometry?.coordinates?.[1],
          lng: f.geometry?.coordinates?.[0],
        },
      }));
      
      // Return with pagination metadata
      return {
        results: mappedReports,
        count: mappedReports.length,
        next: null,
        previous: null,
      };
    }
    
    // If it's a paginated response with results.type = FeatureCollection
    if (data?.results?.type === "FeatureCollection" && Array.isArray(data?.results?.features)) {
      const mappedReports = data.results.features.map((f) => ({
        id:                     f.id || f.properties?.id,
        reported_at:            f.properties?.reported_at,
        description:            f.properties?.description,
        image:                  f.properties?.image,
        stakeholder_confirmed:  f.properties?.stakeholder_confirmed,
        confirmed_at:           f.properties?.confirmed_at,
        solved:                 f.properties?.solved,
        solved_at:              f.properties?.solved_at,
        location: {
          lat: f.geometry?.coordinates?.[1],
          lng: f.geometry?.coordinates?.[0],
        },
      }));
      
      return {
        results: mappedReports,
        count: data.count ?? mappedReports.length,
        next: data.next ?? null,
        previous: data.previous ?? null,
      };
    }
    
    // fallback if flat array or paginated
    if (Array.isArray(data)) {
      return { results: data, count: data.length, next: null, previous: null };
    }
    
    return {
      results: Array.isArray(data?.results) ? data.results : [],
      count: data?.count ?? 0,
      next: data?.next ?? null,
      previous: data?.previous ?? null,
    };
  } catch (error) {
    console.error('Error fetching reports:', error);
    throw error;
  }
};
  

// PATCH /api/incident-reports/{id}/confirm/
export const confirmReport = async ({ id, confirmed }) => {
  const { data } = await apiClient.patch(
    `api/incident-reports/${id}/confirm/`,
    { stakeholder_confirmed: confirmed }
  );
  return data;
};

// DELETE /api/incident-reports/{id}/
export const deleteReport = async (id) => {
  await apiClient.delete(`api/incident-reports/${id}/`);
  return id;
};

export const getReportSignedImageUrl = async (reportId) => {
  const { data } = await apiClient.get(`api/incident-reports/${reportId}/signed-image-url/`);
  return data.image_url;
};
